import React, { FC } from 'react'
import NavDrawer, { NavDrawerGetChildren } from './NavDrawer'
import { useSelector, useDispatch } from 'react-redux'
import MenuList from './MenuList'

import authActions from '../../store/modules/auth'
import authSelectors from '../../store/selectors/auth'

import {
  MenuItem,
} from '../../types/app'

interface SideMenuProps {
  items: MenuItem[],
}

const SideMenu: FC<React.PropsWithChildren<SideMenuProps>> = ({
  items,
}) => {

  const userData = useSelector(authSelectors.data)

  const getChildren: NavDrawerGetChildren = (onClick) => {
    return (
      <MenuList
        items={ items }
        onClick={ onClick }
      />
    )
  }
  
  return (
    userData && (
    <NavDrawer
      getChildren={ getChildren }
    />
    )
  )
}

export default SideMenu